export { default } from "./PermissionTooltip";
